import { useEffect, useRef, useState } from "react";

const appendScript = async ({ id, src, inlineText, attrs = {}, onLoad }) => {
  if (document.getElementById(id)) return;

  const s = document.createElement("script");
  s.id = id;

  if (src) {
    s.src = src;
    s.async = true;

    if (onLoad) {
      s.addEventListener("load", onLoad);
    }
  }

  if (inlineText) {
    s.text = inlineText;
  }

  Object.entries(attrs).forEach(([k, v]) => {
    if (v == null) return;
    s.setAttribute(k, String(v));
  });

  document.body.appendChild(s);
}

function removeByIds(ids) {
  ids.forEach((id) => {
    const el = document.getElementById(id);
    if (el?.parentNode) el.parentNode.removeChild(el);
  });
}

// Hook: inject the correct widget scripts
export function useChatWidgetScripts({
  activeVendor,
  vendorA,
  vendorB,
}) {
  const prevVendorRef = useRef(null);
  const [status, setStatus] = useState("idle");
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const getConfig = (vendor) => {
      if (vendor === "A") return vendorA;
      if (vendor === "B") return vendorB;
      return null;
    }

    const prev = prevVendorRef.current;

    // If vendor changes, remove the old vendor's scripts
    if(prev && prev !== activeVendor){
      const prevCfg = getConfig(prev);
      if(prevCfg?.scriptIdsToManage) removeByIds(prevCfg.scriptIdsToManage);
    }

    if(!activeVendor){
      prevVendorRef.current = null;
      // setStatus("idle");
      // setError(null);
      return;
    }

    const cfg = getConfig(activeVendor);
    if(!cfg){
      // setStatus("error")
      // setError(new Error(`Unknown vendor: ${activeVendor}`))
      return;
    }

    // setStatus("loading");
    // setError(null);

    (async () => {
      try {
        for (const s of cfg.scripts){
          await appendScript(s);
          if(cancelled) return;
        }
        if(!cancelled) {
          prevVendorRef.current = activeVendor;
          // setStatus("ready");
        }
        
      } catch (e) {
        if(!cancelled) {
          // setStatus("error");
          // setError(e);
        }
      }
    })();

    // cleanup on unmount
    return () => {
      cancelled = true;
      const currentCfg = getConfig(activeVendor);
      if(currentCfg?.scriptIdsToManage) removeByIds(currentCfg.scriptIdsToManage)
    };
  }, [activeVendor, vendorA, vendorB]);

  // return { status, error };
  return;
}